import styled from 'styled-components';

import { spacing, colors } from '../../../styles/theme';

const VideoTotalTimeStyles = styled.div`
  font-family: 'Outfit', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: ${spacing('2')};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  letter-spacing: 0.002em;
  color: ${colors('black.base')};
  background: ${colors('white.base')};
  border-radius: 6px;
  position: absolute;
  top: 51.14%;
  left: 68.79%;
  z-index: 99;
  height: 20px;
  width: ${spacing('5')};
`;

export default VideoTotalTimeStyles;
